// React
import React from "react";

// Libraries
import PropTypes from "prop-types";

// Components
import Text from "@Components/Text";
import Pill from "@Components/Pill";
import MessageCard from "../MessageCard";

// Styles
import styles from "./styles.module.css";

const MessageListPrint = ({ sectionsData, messagesData, dataCounts, platformName }) => {
	const getMessagesBySection = () => {
		const grouped = [];
		let msgIndex = 0;

		sectionsData.forEach((section, i) => {
			const count = dataCounts[i];
			const groupMessages = messagesData.slice(msgIndex, msgIndex + count);

			grouped.push({
				section,
				messages: groupMessages,
			});

			msgIndex += count;
		});

		return grouped;
	};

	const groupedMessages = getMessagesBySection();

	return (
		<div className={styles.printWrapper}>
			{groupedMessages.map((group, i) => {
				return (
					<div key={i}>
						<div
							className={styles.datePill}
							style={{
								display: "flex",
								justifyContent: "center",
								margin: "1rem 0",
							}}>
							<Pill>
								<Text>{group.section}</Text>
							</Pill>
						</div>
						<div className={styles.messageCardPrint}>
							{group.messages.map((msg, index) => {
								return <MessageCard key={index} item={msg} isHighlighted={false} platformName={platformName} />;
							})}
						</div>
					</div>
				);
			})}
		</div>
	);
};

MessageListPrint.propTypes = {
	sectionsData: PropTypes.array.isRequired,
	messagesData: PropTypes.array.isRequired,
	dataCounts: PropTypes.array.isRequired,
	platformName: PropTypes.string,
};

export default MessageListPrint;
